import React, { useRef, useEffect } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { FiPlus, FiEdit2 } from 'react-icons/fi';

const ContextMenu = ({ show, x, y, onClose, onAction, training }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (show) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [show, onClose]);

    if (!show) return null;

    // Adjust position to prevent overflow
    const adjustedX = Math.min(x, window.innerWidth - 200);
    const adjustedY = Math.min(y, window.innerHeight - 150);

    return (
        <div 
            ref={menuRef}
            style={{ 
                position: 'fixed', 
                top: adjustedY, 
                left: adjustedX, 
                zIndex: 1050,
                minWidth: '200px',
                animation: 'fadeIn 0.2s ease-out'
            }}
        >
            <Card className="shadow-lg border-0">
                <ListGroup variant="flush">
                    <ListGroup.Item 
                        action 
                        onClick={() => onAction('create')}
                        className="d-flex align-items-center py-2"
                        style={{ cursor: 'pointer' }}
                    >
                        <FiPlus className="me-2 text-primary" />
                        <span>Criar Treinamento</span>
                    </ListGroup.Item>
                    
                    {training && (
                        <ListGroup.Item 
                            action 
                            onClick={() => onAction('edit')}
                            className="d-flex align-items-center py-2"
                            style={{ cursor: 'pointer' }}
                        >
                            <FiEdit2 className="me-2 text-warning" />
                            <span>Editar Treinamento</span>
                        </ListGroup.Item>
                    )}
                </ListGroup>
            </Card>
            <style jsx>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
            `}</style>
        </div>
    );
};

export default ContextMenu;
